module.exports = __webpack_public_path__ + "static/img/3.5abe450.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/3.jpg
// module id = XuyT
// module chunks = 12